import { render, staticRenderFns } from "./BatchResult.vue?vue&type=template&id=bc5d2fac&scoped=true"
import script from "./BatchResult.vue?vue&type=script&lang=js"
export * from "./BatchResult.vue?vue&type=script&lang=js"
import style0 from "./BatchResult.vue?vue&type=style&index=0&id=bc5d2fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5d2fac",
  null
  
)

export default component.exports